import $ from "jquery";
import VOID from "./framework/framework";

const _ = VOID._;

function formatShort(num) {
  if (num === 0) return "0";
  let str = num.toString();
  if (str.slice(0, 2) === "0.") str = str.slice(1);
  return str;
}

const FilterView = VOID.View.extend({
  getTemplateData() {
    return _.pick(this.opts.desc, ["label", "placeholder"]);
  },

  handleShown: _.noop,

  handleOptions: _.noop,

  getName() {
    return this.opts.desc.name;
  }
});

const FilterSearchView = FilterView.extend({
  getTemplateName: VOID.utils.constant("filter_search"),

  handleMounted() {
    $(this.references.input).on("change", () => {
      this.emit(new VOID.Event("change", this));
    });

    $(this.references.button).on("click", () => {
      this.emit(new VOID.Event("change", this));
    });
  },

  handleShown() {
    this.references.input.focus();
  },

  getValue() {
    return this.references.input.value.trim();
  },

  reset() {
    this.references.input.value = "";
  }
});

const FilterSelectView = FilterView.extend({
  getTemplateName: VOID.utils.constant("filter_select"),

  init() {
    this.rememberedOptions = {};

    this.registerSubview(new VOID.BasicView("", this.opts), "name");
  },

  handleMounted() {
    let prevValue = this.getValue();
    this.selectItems = InputComplete.Static([]);
    this.select = initSearchableSelect({
      select: this.references.input,
      template: "searchableSelectTemplate",
      searchOpts: {
        fetch: this.selectItems,
        template: "autocompleteTemplate",
        onSubmit: "set-close",
        minCharacters: 0,
        resetOnBlur: false,
        onSelect: () => {
          const value = this.getValue();
          if (value !== prevValue) {
            if (value) this.indicateActive();
            this.emit(new VOID.Event("change", this));
          }
          prevValue = value;
        }
      }
    });

    $(this.references.reset_btn).on("click", () => {
      this.select.reset();
      this.emit(new VOID.Event("change", this));
    });
  },

  getTextValue() {
    const item = this.select.getSelectedItem();
    return item && item.name || "";
  },

  getValue() {
    return this.references.input.value;
  },

  setOptions(options) {
    const finalOptions = this.transformOptions(options);

    $(this.references.el).toggleClass("dis", !finalOptions.length);

    this.selectItems.setList(finalOptions);
    this.select.setItems(null);
    this.select.selectValue("", true);

    this.indicateFree();

    const rememberByField = this.opts.desc.rememberOptionsByField;
    if (rememberByField) {
      options.forEach(o => {
        this.rememberedOptions[o[rememberByField]] = o;
      });
    }
  },

  transformOptions(options) {
    const optionFields = this.opts.desc.optionFields;
    const finalOptions = [];

    if (options && options.length) {
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        const name = option[optionFields.name];
        const text = name + " (" + option[optionFields.count] + ")";
        const finalOption = {
          text: text,
          html: text,
          value: option[optionFields.value],
          name: name
        };
        finalOptions.push(finalOption);
      }
    }

    return finalOptions;
  },

  indicateFree() {
    $(this.references.select).removeClass("d-none");
    $(this.references.reset_btn).addClass("d-none");
  },

  indicateActive() {
    this.subviews.name[0].setText(this.getTextValue());
    $(this.references.select).addClass("d-none");
    $(this.references.reset_btn).removeClass("d-none");
  },

  reset() {
    this.select.reset();
    this.indicateFree();
  }
});

const FilterSelectStaticView = FilterSelectView.extend({
  transformOptions(map) {
    map = map[0]; // it is a one item array
    const finalOptions = [];

    for (let i = 0; i < this.opts.desc.options.length; i++) {
      const option = this.opts.desc.options[i];
      const mapKey = this.opts.desc.name + option.value;
      const count = +map[mapKey];
      if (count > 0) {
        const text = option.name + " (" + count + ")";
        finalOptions.push({
          text: text,
          html: text,
          value: option.value,
          name: option.name
        });
      }
    }

    return finalOptions;
  }
});

const FilterRadioOptionView = VOID.View.extend({
  getTemplateName: VOID.utils.constant("filter_radio_option"),

  getTemplateData() {
    return this.model;
  },

  init() {
    this.registerSubview(new VOID.BasicView("0", this.opts), "count");
  },

  handleMounted() {
    this.references.option.addEventListener("change", () => {
      this.emit(new VOID.Event("change", this));
    });
  },

  setSelected(state) {
    this.references.option.checked = state;
  },

  isSelected() {
    return this.references.option.checked;
  },

  setCount(count) {
    this.subviews.count[0].setText(count);
    this.references.option.disabled = count == 0;
  }
});

const FilterRadioView = FilterView.extend({
  getTemplateName: VOID.utils.constant("filter_radio"),

  init() {
    var desc = this.opts.desc;

    for (var i = 0; i < desc.options.length; i++) {
      const option = desc.options[i];
      const view = new FilterRadioOptionView(option, this.opts);
      this.registerSubview(view, "options");
      this.listenTo(view, "change", _.bound(this, "handleChange"));
    }
  },

  handleChange: _.throttleFrame(function () {
    this.emit(new VOID.Event("change", this));
  }),

  getSelectedView() {
    return _.find(this.subviews.options, _.invoke("isSelected"));
  },

  getTextValue() {
    const selectedView = this.getSelectedView();
    return selectedView ? selectedView.model.label : "";
  },

  getValue() {
    const selectedView = this.getSelectedView();
    return selectedView ? selectedView.model.value : "";
  },

  setOptions(map) {
    const present = this.setCounts(map);
    $(this.references.el).toggleClass("dis", !present);
  },

  handleOptions(map) {
    this.setCounts(map);
  },

  setCounts(map) {
    map = map[0]; // it is a one item array
    let present = false;
    for (let i = 0; i < this.subviews.options.length; i++) {
      const view = this.subviews.options[i];
      const model = view.model;
      const mapKey = this.opts.desc.name + model.value;
      const count = map[mapKey];
      present = present || count > 0;
      view.setCount(count);
    }
    return present;
  },

  reset() {
    for (let i = 0; i < this.subviews.options.length; i++) {
      const view = this.subviews.options[i];
      view.setSelected(false);
    }
  }
});

const filterViewsByType = {
  search: FilterSearchView,
  select: FilterSelectView,
  "select-static": FilterSelectStaticView,
  radio: FilterRadioView,
};

const ListItemView = VOID.View.extend({
  getTemplateName() {
    return this.opts.listItemTemplateName
  },

  getTemplateData() {
    return _.mapObject(this.model, function (value, key) {
      return /marked/i.test(key) ? value : htmlEntities(value);
    });
  },

  handleMounted() {
    this.references.item.addEventListener("click", () => {
      this.emit(new VOID.Event("click", this));
    });
    this.references.item.addEventListener("dblclick", () => {
      this.emit(new VOID.Event("dblclick", this));
    });
  },

  toggleActive(state) {
    this.toggleClass("item", "table-active", !!state);
  },

  getColCount() {
    return this.references.item.childElementCount;
  }
});

const ListView = VOID.View.extend({
  getTemplateName: VOID.utils.constant("list"),

  init() {
    this.addEmptyPlacement("items");
    this.selectedItem = null;
  },

  setList(items) {
    this.destroySubviewsAt("items");
    this.addList(items);
  },

  addList(items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var view = new ListItemView(item, this.opts);
      this.listenTo(view, "click", evt => {
        this.handleItemClick(evt.target.model);
      });
      this.listenTo(view, "dblclick", evt => {
        this.setSelectedItem(evt.target.model);
        this.emit(new VOID.Event("confirm", this));
      });
      this.registerSubview(view, "items");
    }

    this.handleListUpdate();
  },

  handleItemClick(item) {
    if (this.setSelectedItem(item)) this.updateSelectedView();
  },

  handleListUpdate() {
    if (!this.updateSelectedView()) {
      this.selectedItem = null;
      this.emit(new VOID.Event("change", this));
    }
  },

  setSelectedItem(item) {
    if (!this.selectedItem !== !item || this.selectedItem && item && item.UID !== this.selectedItem.UID) {
      this.selectedItem = item;
      this.emit(new VOID.Event("change", this));
      return true;
    }
    return false;
  },

  updateSelectedView() {
    let found = false;
    for (let i = 0; i < this.subviews.items.length; i++) {
      const view = this.subviews.items[i];
      const match = this.selectedItem && this.selectedItem.UID === view.model.UID;
      found = found || match;
      view.toggleActive(match);
    }
    return found;
  },

  getColCount() {
    const item = this.subviews.items[0];
    return item ? item.getColCount() : 0;
  }
});

const Picker = VOID.View.extend({
  getName: VOID.utils.constant("picker"),
  getTemplateName: VOID.utils.constant("base"),

  getTemplateData() {
    return {
      modal_id: this.opts.modalID,
      head: this.opts.head,
      submit_label: this.opts.submitLabel,
    };
  },

  init() {
    this.initFilters();
    this.initListView();

    this.requestParams = {s: 0, ppg: 20};

    this.inRequest = false;
    this.registerSubview(new VOID.BasicView("...", this.opts), "count");
    this.registerSubview(new VOID.BasicView("", this.opts), "more_btn_text");
  },

  handleMounted() {
    this.spinner = new VOID.utils.ClassDelayedToggler({
      el: this.references.body,
      className: "spinning",
      duration: 250,
      delay: 150
    });

    this.references.reset_btn.addEventListener("click", () => {
      this.reset();
    });

    this.references.submit_btn.addEventListener("click", () => {
      this.confirm();
    });

    this.references.more_btn.addEventListener("click", evt => {
      this.request({add: true});
      evt.preventDefault();
    });

    this.$modal = $("#" + this.opts.modalID);

    this.$modal.on("shown.bs.modal", () => {
      this.handleShown();
    });

    this.$modal.on("hidden.bs.modal", () => {
      this.reset();
    });

    this.request();
  },

  handleShown() {
    this.filters.forEach(function (filter) {
      filter.view.handleShown();
    });
  },

  confirm() {
    const cb = this.opts.onSelect;
    const value = this.subviews.list[0].selectedItem;
    if (cb) cb(value);
    this.emit(new VOID.Event("select", this, {value: value}));
    this.$modal.modal("hide");
  },

  getFilterDescriptions() {
    return this.opts.filters;
  },

  getFilterByName(name) {
    const filter = _.find(this.filters, _.compose(_.equal(name), _.propertyDeep("view.opts.desc.name")));
    return filter && filter.view;
  },

  initFilters() {
    const filters = this.filters = this.getFilterDescriptions();
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      const opts = Object.assign({}, this.opts, {desc: filter});
      const view = new filterViewsByType[filter.type](this.model, opts);
      filter.view = view;
      view.on("change", _.bound(this, "handleFilterChange"));
      this.registerSubview(view, "filters");
    }
  },

  initListView() {
    const view = new ListView(this.model, this.opts);

    this.listenTo(view, "change", evt => {
      $(this.references.submit_btn).prop("disabled", !evt.target.selectedItem);
    });

    this.listenTo(view, "confirm", () => {
      this.confirm();
    });

    this.registerSubview(view, "list");
  },

  getFilterValues() {
    const out = {};
    for (let i = 0; i < this.subviews.filters.length; i++) {
      const view = this.subviews.filters[i];
      out[view.getFilterName()] = view.getValue();
    }
    return out;
  },

  request(opts) {
    if (this.inRequest) return;
    this.inRequest = true;

    const add = opts && opts.add;

    if (add) {
      this.requestParams.s += this.requestParams.ppg;
    } else {
      this.requestParams.s = 0;
    }

    const params = Object.assign({}, this.opts.additionalParams, this.requestParams);
    const queriedLists = ["list", "misc"];
    const queriedListNames = [];

    this.filters.forEach(filter => {
      const value = filter.view.getValue();
      const name = filter.name;
      const listName = filter.listName;
      if (value) {
        params[name] = value;
      } else if (listName) {
        queriedLists.push(listName);
        queriedListNames.push(name);
      }
    });

    this.spinner.on(function () {
      AJAX.spinnerCenterer.update();
    });

    const listParam = _.uniq(queriedLists).join(",");
    const url = alterQueryString(this.opts.url, params, {ajax: "getlists", list: listParam});
    VOID.utils.ajax({
      url: url,
      method: "GET",
      success: json => {
        this.spinner.off(() => {
          const data = JSON.parse(json)[0];
          const count = +data.misc[0].count;
          const rest = Math.min(count - (this.requestParams.s + this.requestParams.ppg), this.requestParams.ppg);

          $(this.references.empty_list).toggleClass("d-none", count !== 0);
          $(this.references.table).toggleClass("d-none", count === 0);

          if (add) {
            this.subviews.list[0].addList(data.list);
          } else {
            $(this.references.scroller).scrollTop(0);
            this.subviews.list[0].setList(data.list);
          }

          $(this.references.more_btn_el)
            .toggleClass("d-none", rest <= 0)
            .attr("colspan", this.subviews.list[0].getColCount());

          this.filters.forEach(filter => {
            if (queriedListNames.indexOf(filter.name) !== -1) {
              filter.view.setOptions(data[filter.listName]);
            } else {
              filter.view.handleOptions(data[filter.listName]);
            }
          });

          this.subviews.count[0].setText(count);
          this.subviews.more_btn_text[0].setText(VOID.Lang.translate("seekbarMore", {rest: rest}));

          this.inRequest = false;
        });
      }
    });
  },

  handleFilterChange() {
    this.request();
  },

  reset() {
    this.filters.forEach(function (filter) {
      filter.view.reset();
    });
    this.request();
  }
});

export const Pickers = {
  create(opts) {
    const view = new Picker(null, opts);
    view.appendTo(document.body);
    return view;
  }
};
